import { makeDefinitionFor } from '../../../helpers/endpoint.definition.details.generator';
import { generateValidationError, success } from '../../../shared/api.response.def';
import { job } from '../../../shared/job.def';

export const definition = makeDefinitionFor(
	'/job/{job_id}.json',
	{
		description: 'Get information on a single job',
		method: 'get',
		summary: 'Job Information',
		tags: ['Job'],
		params: [
			{
				$ref: '#/components/parameters/ikeDepartmentId',
			},
			{
				$ref: '#/components/parameters/jobIdPath',
			},
		],
	},
	[
		{
			code: 200,
			description: success,
			schema: job,
		},
		generateValidationError(),
	]
);
